__turbopack_context__.v({
  "actionHeader": "synchrony-section-module-scss-module__A_vt1a__actionHeader",
  "buttonContainer": "synchrony-section-module-scss-module__A_vt1a__buttonContainer",
  "buttonGroup": "synchrony-section-module-scss-module__A_vt1a__buttonGroup",
  "campaignMonthlyCost": "synchrony-section-module-scss-module__A_vt1a__campaignMonthlyCost",
  "cashBackBannerContent": "synchrony-section-module-scss-module__A_vt1a__cashBackBannerContent",
  "cashBackBannerImage": "synchrony-section-module-scss-module__A_vt1a__cashBackBannerImage",
  "cashBackBannerText": "synchrony-section-module-scss-module__A_vt1a__cashBackBannerText",
  "cashBackBannerWrapper": "synchrony-section-module-scss-module__A_vt1a__cashBackBannerWrapper",
  "cashBackSection": "synchrony-section-module-scss-module__A_vt1a__cashBackSection",
  "cashbackSubheading": "synchrony-section-module-scss-module__A_vt1a__cashbackSubheading",
  "cashbackTextSection": "synchrony-section-module-scss-module__A_vt1a__cashbackTextSection",
  "container": "synchrony-section-module-scss-module__A_vt1a__container",
  "detail": "synchrony-section-module-scss-module__A_vt1a__detail",
  "detailHeading": "synchrony-section-module-scss-module__A_vt1a__detailHeading",
  "detailSubtext": "synchrony-section-module-scss-module__A_vt1a__detailSubtext",
  "detailsContainer": "synchrony-section-module-scss-module__A_vt1a__detailsContainer",
  "detailsTop": "synchrony-section-module-scss-module__A_vt1a__detailsTop",
  "disclaimer": "synchrony-section-module-scss-module__A_vt1a__disclaimer",
  "headerBanner": "synchrony-section-module-scss-module__A_vt1a__headerBanner",
  "lowCostheading": "synchrony-section-module-scss-module__A_vt1a__lowCostheading",
  "modalBody": "synchrony-section-module-scss-module__A_vt1a__modalBody",
  "offerBreakdown": "synchrony-section-module-scss-module__A_vt1a__offerBreakdown",
  "offerContainer": "synchrony-section-module-scss-module__A_vt1a__offerContainer",
  "offerDetails": "synchrony-section-module-scss-module__A_vt1a__offerDetails",
  "offerPayments": "synchrony-section-module-scss-module__A_vt1a__offerPayments",
  "payments": "synchrony-section-module-scss-module__A_vt1a__payments",
  "promotionPeriod": "synchrony-section-module-scss-module__A_vt1a__promotionPeriod",
  "screenReader": "synchrony-section-module-scss-module__A_vt1a__screenReader",
  "sleepExpert": "synchrony-section-module-scss-module__A_vt1a__sleepExpert",
  "sleepExpertSection": "synchrony-section-module-scss-module__A_vt1a__sleepExpertSection",
  "validDates": "synchrony-section-module-scss-module__A_vt1a__validDates",
});
